import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import { GroupAdd } from '@mui/icons-material'
import { useLang } from '~/hooks/useLang'
import { useHookstate } from '@hookstate/core'
import EntrySetDispatchGroupDialog from './components/EntrySetDispatchGroupDialog'

interface DispatchCopyButtonProps {
  readonly canSetDispatchGroup: boolean | undefined
  readonly setManuallyDispatchGroup: (params: any) => Promise<boolean> | undefined
}

export default function EntrySetDispatchGroupButton({
  ...props
}: DispatchCopyButtonProps) {
  const { translate } = useLang()
  const open = useHookstate(false)

  return (
    <Grid item>
      <Tooltip
        title={translate('Add Dispatch Group')}
        placement="right-start"
        componentsProps={{ tooltip: { sx: { fontSize: '14px' } } }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton
            disabled={!props.canSetDispatchGroup}
            onClick={() => open.set(true)}
          >
            <GroupAdd />
          </IconButton>
        </span>
      </Tooltip>
      {open.get() && (
        <EntrySetDispatchGroupDialog
          open={open}
          setManuallyDispatchGroup={props.setManuallyDispatchGroup}
        />
      )}
    </Grid>
  )
}
